import { Component, OnInit } from '@angular/core';
import { ProjectsService } from '../../services/projects.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrl: './projects.component.scss'
})
export class ProjectsComponent implements OnInit {
  projects: Array<any> = [];
  updatingStatus: boolean = false;

  constructor(private readonly projectService: ProjectsService, private readonly router: Router){ }

  ngOnInit(): void {
    this.projectService.getAllProjects().subscribe((_: any) => this.projects = _);
  }

  complete(projectId: string) {
    this.updatingStatus = true;
    this.projectService.completeProject(projectId).subscribe({
      next: (_: any) => {
        this.router.navigate([this.router.url]);
      },
      error: (_: any) => {
        console.error('error stopping project', _);
        this.router.navigate([this.router.url]);
      }
    });

  }
  start(projectId: string) {
    this.updatingStatus = true;
    this.projectService.startProject(projectId).subscribe({
      next: (_: any) => {
        this.router.navigate([this.router.url]);
      },
      error: (_: any) => {
        console.error('error starting project', _);
        this.router.navigate([this.router.url]);
      }
    });
  }

}
